import { render, staticRenderFns } from "./StoreList.vue?vue&type=template&id=21d695d0&"
import script from "./StoreList.vue?vue&type=script&lang=ts&"
export * from "./StoreList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports